<template>
  <div class="underline pointer" @click="TogglePubilsh()">
    {{ isPublish }}
  </div>
</template>

<script>
import axios from "../../../../util/backend";
import { mapGetters } from "vuex";
import baseUrl from "../../../../util/baseUrl";

export default {
  mounted() {
    this.is_public
      ? (this.status = this.is_public.public)
      : (this.status = this.params.value.public);
  },
  computed: {
    isPublish: function() {
      return this.status == true ? "เผยเเพร่อยู่" : "ยังไม่ได้เผยเเพร่";
    },
    ...mapGetters({
      pointer: "general/pointer"
    })
  },
  methods: {
    async TogglePubilsh() {
      let config;
      switch (this.pointer) {
        case "curriculum":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/toggleCurriculumPublic`,
            data: {
              curriculum_id: this.params.value.id,
              is_public: !this.status
            }
          };

          break;

        case "course":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/toggleCoursePublic`,
            data: {
              course_id: this.params.value.id,
              is_public: !this.status
            }
          };

          break;
        case "video":
          if (this.is_public) {
            config = {
              method: "put",
              url: `${baseUrl.baseurl()}/toggleCoursePublic`,
              data: {
                course_id: this.is_public.id,
                is_public: !this.status
              }
            };
          } else {
            config = {
              method: "put",
              url: `${baseUrl.baseurl()}/toggleVideoPublic`,
              data: {
                video_id: this.params.value.id,
                is_public: !this.status
              }
            };
          }

          break;
        case "banner":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/toggleBannerPublic`,
            data: {
              banner_id: this.params.value.id,
              is_public: !this.status
            }
          };

          break;

        default:
          break;
      }
      await axios
        .api(config)
        .then(res => {
          this.status = !this.status;
        })
        .catch(err => {
          this.$vs.notify({
            title: "Error message",
            text: `${err.response.data.error ? err.response.data.error : err}`,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        });
    }
  },
  data() {
    return {
      status: null
    };
  },

  props: {
    is_public: Object
  }
};
</script>

<style lang="scss" scoped></style>
